<script setup lang="ts">
/**
 * @author Giorgi Tseradze
 */

//
import "swiper/css";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import { onBeforeMount, onMounted, ref, Ref, watch } from "vue";
import LeftArrowSVG from "./SVG/LeftArrowSVG.vue";
import RightArrowSVG from "./SVG/RightArrowSVG.vue";
import { useMainStore } from "@/store/main/index";
import { handleSwipeDirection } from "@/composables/utils/swipeHandler";
import { ImageInterface, SecondaryDataInterface } from "@/types/ContentType";
const Picture = defineAsyncComponent(
  () => import("@/components/regularComponents/UIComponents/Picture.vue")
);

const props = defineProps<{
  contentData: SecondaryDataInterface;
}>();
const mainStore = useMainStore();
const content: Ref<ImageInterface[]> = ref([]);

const {
  handleSwipeStart,
  handleSwipeEnd,
  handleMouseSwipeStart,
  handleMouseSwipeEnd,
  direction,
} = handleSwipeDirection();

const NavigationOptions = {
  enabled: true,
  nextEl: ".carousel__arrows-next",
  prevEl: ".carousel__arrows-prev",
};

const onEvents = {
  touchstart(e: TouchEvent) {
    handleSwipeStart(e);
  },
  touchend(e: TouchEvent) {
    handleSwipeEnd(e);
  },
  mousedown(e: MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
    handleMouseSwipeStart(e);
  },
  mouseup(e: MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
    handleMouseSwipeEnd(e);
  },
};

const swiperInstance: any = ref();

let prevSlide;
let duplicatePrevSlide: any;
const handleSlides = (sw: any) => {
  sw.slides.forEach((item: any, index: number, arr: any) => {
    if (item.classList.value.includes("swiper-slide-prev")) {
      prevSlide = index;
    }
    if (item.classList.value.includes("swiper-slide-duplicate-prev")) {
      duplicatePrevSlide = index;
    }

    if (index < sw.activeIndex) {
      if (mainStore?.windowWidth >= 3840) {
        item.style.transform = "scale(1) translateX(-338px)";
      }
      if (mainStore?.windowWidth <= 3839 && mainStore?.windowWidth > 2800) {
        item.style.transform = "scale(1) translateX(-315px)";
      }
      if (mainStore?.windowWidth <= 2800 && mainStore?.windowWidth > 2559) {
        item.style.transform = "scale(1) translateX(-225.5px)";
      }
      if (mainStore?.windowWidth <= 2559 && mainStore?.windowWidth > 983) {
        item.style.transform = "scale(1) translateX(-169px)";
      }
      if (mainStore?.windowWidth <= 983) {
        item.style.transform = "scale(1) translateX(-0px)";
      }
    } else if (index > sw.activeIndex) {
      if (mainStore?.windowWidth >= 3840) {
        item.style.transform = "scale(1) translateX(338px)";
      }
      if (mainStore?.windowWidth <= 3839 && mainStore?.windowWidth > 2800) {
        item.style.transform = "scale(1) translateX(315px)";
      }
      if (mainStore?.windowWidth <= 2800 && mainStore?.windowWidth > 2559) {
        item.style.transform = "scale(1) translateX(225.5px)";
      }
      if (mainStore?.windowWidth <= 2559 && mainStore?.windowWidth > 2559) {
        item.style.transform = "scale(1) translateX(169px)";
      }
      if (mainStore?.windowWidth <= 983) {
        item.style.transform = "scale(1) translateX(0px)";
      }
    }
    if (
      sw.realIndex == content?.value?.length - 1 &&
      arr[duplicatePrevSlide - 1] &&
      arr[duplicatePrevSlide - 2]
    ) {
      if (mainStore?.windowWidth >= 3840) {
        arr[duplicatePrevSlide - 1].style.transform = "scale(1) translateX(-338px)";
        arr[duplicatePrevSlide - 2].style.transform = "scale(1) translateX(-338px)";
        arr[duplicatePrevSlide - 3].style.transform = "scale(1) translateX(-338px)";
      }
      if (mainStore?.windowWidth <= 3839 && mainStore?.windowWidth > 2800) {
        arr[duplicatePrevSlide - 1].style.transform = "scale(1) translateX(-315px)";
        arr[duplicatePrevSlide - 2].style.transform = "scale(1) translateX(-315px)";
        arr[duplicatePrevSlide - 3].style.transform = "scale(1) translateX(-315px)";
      }
      if (mainStore?.windowWidth <= 2800 && mainStore?.windowWidth > 2559) {
        arr[duplicatePrevSlide - 1].style.transform = "scale(1) translateX(-225.5px)";
        arr[duplicatePrevSlide - 2].style.transform = "scale(1) translateX(-225.5px)";
        arr[duplicatePrevSlide - 3].style.transform = "scale(1) translateX(-225.5px)";
      }
      if (mainStore?.windowWidth <= 2559 && mainStore?.windowWidth > 983) {
        arr[duplicatePrevSlide - 1].style.transform = "scale(1) translateX(-169px)";
        arr[duplicatePrevSlide - 2].style.transform = "scale(1) translateX(-169px)";
        arr[duplicatePrevSlide - 3].style.transform = "scale(1) translateX(-169px)";
      }
      if (mainStore?.windowWidth <= 983) {
        arr[duplicatePrevSlide - 1].style.transform = "scale(1) translateX(-0px)";
        arr[duplicatePrevSlide - 2].style.transform = "scale(1) translateX(-0px)";
        arr[duplicatePrevSlide - 3].style.transform = "scale(1) translateX(-0px)";
      }
    }
  });
};
let nextSlide;
let duplicateNextSlide: any;
const handleSlides2 = (sw: any) => {
  sw.slides.forEach((item: any, index: number, arr: any) => {
    if (item.classList.value.includes("swiper-slide-next")) {
      nextSlide = index;
    }
    if (item.classList.value.includes("swiper-slide-duplicate-next")) {
      duplicateNextSlide = index;
    }

    const realIndex = Number(item.getAttribute("data-swiper-slide-index"));

    if (index < sw.activeIndex) {
      if (mainStore?.windowWidth >= 3840) {
        item.style.transform = "scale(1) translateX(-338px)";
      }
      if (mainStore?.windowWidth <= 3839 && mainStore?.windowWidth > 2800) {
        item.style.transform = "scale(1) translateX(-315px)";
      }
      if (mainStore?.windowWidth <= 2800 && mainStore?.windowWidth > 2559) {
        item.style.transform = "scale(1) translateX(-225.5px)";
      }
      if (mainStore?.windowWidth <= 2559 && mainStore?.windowWidth > 983) {
        item.style.transform = "scale(1) translateX(-169px)";
      }
      if (mainStore?.windowWidth <= 983) {
        item.style.transform = "scale(1) translateX(-0px)";
      }
    } else if (index > sw.activeIndex) {
      if (mainStore?.windowWidth >= 3840) {
        item.style.transform = "scale(1) translateX(338px)";
      }
      if (mainStore?.windowWidth <= 3839 && mainStore?.windowWidth > 2800) {
        item.style.transform = "scale(1) translateX(315px)";
      }
      if (mainStore?.windowWidth <= 2800 && mainStore?.windowWidth > 2559) {
        item.style.transform = "scale(1) translateX(225.5px)";
      }
      if (mainStore?.windowWidth <= 2559 && mainStore?.windowWidth > 983) {
        item.style.transform = "scale(1) translateX(169px)";
      }
      if (mainStore?.windowWidth <= 983) {
        item.style.transform = "scale(1) translateX(0px)";
      }
    }

    if (sw.realIndex == 0 && arr[duplicateNextSlide + 1]) {
      if (mainStore?.windowWidth >= 3840) {
        arr[duplicateNextSlide + 1].style.transform = "scale(1) translateX(338px)";
      }
      if (mainStore?.windowWidth <= 3839 && mainStore?.windowWidth > 2800) {
        arr[duplicateNextSlide + 1].style.transform = "scale(1) translateX(315px)";
      }
      if (mainStore?.windowWidth <= 2800 && mainStore?.windowWidth > 2559) {
        arr[duplicateNextSlide + 1].style.transform = "scale(1) translateX(225.5px)";
      }
      if (mainStore?.windowWidth <= 2559 && mainStore?.windowWidth > 983) {
        arr[duplicateNextSlide + 1].style.transform = "scale(1) translateX(169px)";
      }
      if (mainStore?.windowWidth <= 983) {
        arr[duplicateNextSlide + 1].style.transform = "scale(1) translateX(0px)";
      }
    }
  });
};

const getSwiperInstance = (sw: any) => {
  swiperInstance.value = sw;

  sw.on("touchMove", () => {});

  sw.on("touchStart", () => {
    sw.slides.forEach((slide: HTMLElement) => {
      slide.classList.add("swiper-slide--grabbed");
    });
  });

  sw.on("touchEnd", () => {
    sw.slides.forEach((slide: HTMLElement) =>
      slide.classList.remove("swiper-slide--grabbed")
    );
  });
  handleSlides2(sw);

  sw.on("slideNextTransitionStart", () => {
    handleSlides2(sw);
  });
  sw.on("slideNextTransitionEnd", () => {
    setTimeout(() => {
      handleSlides2(sw);
    }, 900);
  });

  sw.on("slidePrevTransitionStart", () => {
    handleSlides(sw);
  });
  sw.on("slidePrevTransitionEnd", () => {
    setTimeout(() => {
      handleSlides(sw);
    }, 900);
  });
};

onBeforeMount(() => {
  content.value = props?.contentData?.data?.list?.[0]?.image;
  const length = content?.value?.length;
  if (length < 7) {
    for (let i = 0; i < 7 - length; i++) {
      content?.value?.push(content?.value?.[i % length]);
    }
  }
});

const slideNav = (isRight: boolean) => {
  if (mainStore?.windowWidth > 1247) {
    if (isRight) {
      swiperInstance.value.slideNext();
    } else {
      swiperInstance.value.slidePrev();
    }
  } else {
    if (isRight) {
      swiperInstance.value.slidePrev();
    } else {
      swiperInstance.value.slideNext();
    }
  }
};

watch(direction, (ns) => {
  if (ns === "LEFT") {
    slideNav(false);
  } else if (ns === "RIGHT") {
    slideNav(true);
  }
});
</script>

<template>
  <section class="carousel pos-rel">
    <div class="carousel__inner pos-rel" v-on="onEvents">
      <Swiper
        @swiper="getSwiperInstance"
        :updateOnWindowResize="true"
        :centeredSlides="mainStore?.windowWidth < 984 ? true : false"
        :loop="true"
        :grabCursor="true"
        :slidesPerView="'auto'"
        :key="mainStore?.windowWidth"
        :speed="800"
        :loopPreventsSliding="true"
        :allowTouchMove="false"
        :modules="[Navigation]"
        :navigation="NavigationOptions"
      >
        <SwiperSlide v-for="(item, index) in content" :key="index">
          <div class="carousel__card pos-rel no-flicker pos-rel">
            <Picture
              :devices="item?.devices"
              alt="apartment slide"
              class="img-absolute no-flicker"
            />
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
    <div class="carousel__arrows d-flex pos-abs">
      <div class="carousel__arrows-prev">
        <LeftArrowSVG class="carousel__arrows-icon" />
      </div>
      <div class="carousel__arrows-next">
        <RightArrowSVG class="carousel__arrows-icon" />
      </div>
    </div>
  </section>
</template>

<style lang="scss">
.carousel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 415px;
  @include maxq(desktop-2k) {
    padding-top: 276px;
  }
  @include maxq(desktop-lg) {
    padding-top: 207px;
  }
  @include maxq(mobile) {
    padding-top: 143px;
  }
  &__inner {
    display: flex;
    justify-content: center;
    width: 100%;
    padding-bottom: 790px;
    @include mqMinMax(2801px, 3839px) {
      padding-bottom: 710px;
    }
    @include mqMinMax(2560px, 2800px) {
      padding-bottom: 515px;
    }
    @include maxq(desktop-lg) {
      padding-bottom: 390px;
    }
    @include maxq(mobile) {
      padding-bottom: 335px;
    }
    @include maxq(mobile-sm) {
      padding-bottom: 260px;
    }
  }
  &__card {
    width: 100%;
    padding-top: calc(100% / (676 / 676));
    @include mqMinMax(2801px, 3839px) {
      padding-top: calc(100% / (630 / 630));
    }
    @include mqMinMax(2560px, 2800px) {
      padding-top: calc(100% / (451 / 451));
    }
    height: 0;
    @include maxq(mobile) {
      padding-top: calc(100% / (338 / 338));
    }
  }
  .swiper {
    margin-left: 59.65438446158241%;
    overflow: visible;
    width: 19.309%;
    height: 100%;
    @include maxq(desktop) {
      width: 26.615%;
      margin-left: 53.5%;
    }
    @include maxq(desktop-sm) {
      width: 34.35%;
      margin-left: 43%;
    }
    @include maxq(mobile) {
      width: 57.2%;
      margin-left: 24.3%;
    }
    .swiper-slide {
      width: 676px;
      height: 100%;
      margin-right: 48px;
      transition: all 0.5s cubic-bezier(0.27, 0.39, 0.38, 0.49);
      @include mqMinMax(2801px, 3839px) {
        width: 630px;
        margin-right: 40px;
      }
      @include mqMinMax(2560px, 2800px) {
        width: 451px;
        margin-right: 32px;
      }
      @include maxq(desktop-lg) {
        width: 338px;
        margin-right: 24px;
      }
      @include maxq(mobile) {
        width: 376px;
      }
      @include maxq(mobile-sm) {
        width: 250px;
      }
    }
    .swiper-slide {
      &-next,
      &-duplicate-next {
        transform: translateX(338px) scale(1) !important;
        @include mqMinMax(2801px, 3839px) {
          transform: translateX(315px) scale(1) !important;
        }
        @include mqMinMax(2560px, 2800px) {
          transform: translateX(225.5px) scale(1) !important;
        }
        @include maxq(desktop-lg) {
          transform: translateX(169px) scale(1) !important;
        }
        @include maxq(mobile) {
          transform: translateX(0px) scale(1) !important;
        }

        & + .swiper-slide {
          transform: translateX(338px) scale(1) !important;
          @include mqMinMax(2801px, 3839px) {
            transform: translateX(315px) scale(1) !important;
          }
          @include mqMinMax(2560px, 2800px) {
            transform: translateX(225.5px) scale(1) !important;
          }
          @include maxq(desktop-lg) {
            transform: translateX(169px) scale(1) !important;
          }
          @include maxq(mobile) {
            transform: translateX(0px) scale(1) !important;
          }
        }
      }
      &-prev,
      &-duplicate-prev {
        transform: translateX(-338px) scale(1) !important;
        @include mqMinMax(2801px, 3839px) {
          transform: translateX(-315px) scale(1) !important;
        }
        @include mqMinMax(2560px, 2800px) {
          transform: translateX(-225.5px) scale(1) !important;
        }
        @include maxq(desktop-lg) {
          transform: translateX(-169px) scale(1) !important;
        }
        @include maxq(mobile) {
          transform: translateX(0px) scale(1) !important;
        }
      }
    }
    .swiper-slide-active,
    .swiper-slide-duplicate-active {
      position: relative;
      transform-origin: top;
      transform: translateX(0) scale(2) !important;
      @include maxq(mobile) {
        margin-left: initial;
        margin-right: 24px;
        transform: initial;
        transform: scaleY(1.766) !important;
        @include easeOut(1100, transform);
      }
      .carousel__card {
      }
    }
    .carousel__card {
    }
  }
  &__arrows {
    display: flex;
    top: 1800px;
    margin-left: 8%;
    @include mqMinMax(2801px, 3839px) {
      top: 1570px;
      margin-left: 6%;
    }
    @include mqMinMax(2560px, 2800px) {
      top: 1200px;
      margin-left: 7.3%;
    }
    @include maxq(desktop-lg) {
      top: 895px;
      margin-left: 10%;
    }
    @include maxq(desktop) {
      margin-left: -5%;
    }
    @include maxq(desktop-sm) {
      margin-left: -30%;
    }
    @include maxq(mobile) {
      top: 820px;
      margin-left: -23%;
    }
    @include maxq(mobile-sm) {
      top: 600px;
      margin-left: -23%;
    }
    &-icon {
      width: 100%;
      height: 100%;
      display: flex;
    }
    &-prev {
      width: 127px;
      height: 64px;
      cursor: pointer;
      transform: translateX(0);
      opacity: 1;
      @include maxq(desktop-2k) {
        width: 79px;
        height: 40px;
      }
      @include maxq(desktop-lg) {
        width: 64px;
        height: 32px;
      }
      @include easeOut(350, all);
      @include hover {
        transform: translateX(-15%);
        @include easeOut(500, transform);
      }
    }
    &-next {
      cursor: pointer;
      width: 127px;
      height: 64px;
      right: 22.5%;
      transform: translateX(15%);
      opacity: 1;
      @include easeOut(350, all);
      @include maxq(desktop-2k) {
        width: 79px;
        height: 40px;
      }
      @include maxq(desktop-lg) {
        transform: translateX(10%);
        width: 64px;
        height: 32px;
      }
      @include hover {
        transform: translateX(35%);
        @include maxq(desktop-lg) {
          transform: translateX(30%);
        }
        @include easeOut(500, transform);
      }
    }
  }
}
</style>
